var Split;
(function (Split) {
    Split["ExperimentSinglePricingTier"] = "experiment_single_pricing_tier";
    Split["FeatureGlobalHeader"] = "feature_global_header";
    Split["FeatureSinglePricingTier"] = "feature_single_pricing_tier";
    Split["FeatureBridgingWorkaround"] = "feature_bridging_workaround";
    Split["MoneyPlatformIintegration"] = "money_platform_integration";
    Split["FeatureMarketplaceUpdates"] = "feature_marketplace_updates";
    Split["DigitalLabsFooterFeature"] = "feature_digital_labs_footer";
    Split["FeatureRoadsidePage"] = "feature_roadside_page";
    Split["FeaturePreventDuplicateMemberships"] = "feature_prevent_duplicate_memberships";
    Split["FeatureEnthusiastHdc"] = "feature_enthusiast_hdc";
})(Split || (Split = {}));
var Treatment;
(function (Treatment) {
    Treatment["On"] = "on";
    Treatment["Off"] = "off";
    Treatment["Omni"] = "omni";
    Treatment["MemberGraph"] = "member_graph";
    Treatment["BothOmni"] = "both_omni";
    Treatment["BothMemberGraph"] = "both_member_graph";
})(Treatment || (Treatment = {}));
export { Split, Treatment };
